<template>
	<div class="check-view" @click.stop="click">
		<svg-icon v-show="value" width="8px" height="8px" icon="close" style="fill: #f7223f;" />
	</div>
</template>

<script>
	export default {
		props: {
			data: {
				default: null
			},
			value: {
				type: [Boolean, Array],
				default: false
			}
		},
		methods: {
			click() {
				this.$emit('input', !this.value, this.data);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.check-view {
		width: 16px;
		height: 16px;
		border: 1px solid rgb(209, 209, 209);
		cursor: pointer;
		line-height: 12px;
		padding-left: 3px;
		background-color: white;
	}
</style>